
import * as imagekitRuntime$JepJry8Xcs from '/Users/olivermurphy/Code/spas/justhire/node_modules/@nuxt/image-edge/dist/runtime/providers/imagekit'
import * as storyblokRuntime$jLv4uz7Rvj from '/Users/olivermurphy/Code/spas/justhire/node_modules/@nuxt/image-edge/dist/runtime/providers/storyblok'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imagekit",
  "domains": [
    "imagekit.io",
    "ik.imagekit.io"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['imagekit']: { provider: imagekitRuntime$JepJry8Xcs, defaults: {"baseURL":"https://ik.imagekit.io/justhire"} },
  ['storyblok']: { provider: storyblokRuntime$jLv4uz7Rvj, defaults: {"baseURL":"https://a.storyblok.com"} }
}
        